import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fileUrl } from "@/lib/api";
import { ShieldCheck, ArrowUpRight } from "lucide-react";

export default function TrustSpotlight() {
  const [sellers, setSellers] = useState([]);
  useEffect(() => { api.get("/sellers/top").then((r) => setSellers(r.data)).catch(() => {}); }, []);
  if (sellers.length === 0) return null;

  return (
    <section className="max-w-[1600px] mx-auto px-6 lg:px-12 pb-16" data-testid="trust-spotlight">
      <div className="flex items-end justify-between mb-6">
        <div>
          <div className="label-eyebrow" style={{ color: "#16A34A" }}>Trusted sellers</div>
          <h2 className="font-display text-3xl md:text-4xl tracking-tight mt-2">Screened, proven, spotless.</h2>
          <p className="mt-2 text-sm text-neutral-500 max-w-xl">
            Sellers with three or more AI-verified authentic listings and a clean record.
          </p>
        </div>
        <Link to="/browse?verified_only=1" className="btn-outline hidden md:inline-flex" data-testid="spotlight-browse-verified">
          Shop verified <ArrowUpRight size={14} />
        </Link>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {sellers.map((s) => (
          <Link key={s.seller_id} to={`/browse?seller_id=${s.seller_id}&verified_only=1`}
            data-testid={`spotlight-seller-${s.seller_id}`}
            className="hairline card-lift bg-white overflow-hidden">
            <div className="aspect-square bg-neutral-50 overflow-hidden">
              {s.image_path
                ? <img src={fileUrl(s.image_path)} alt="" className="w-full h-full object-cover" />
                : <div className="w-full h-full flex items-center justify-center label-eyebrow">No photo</div>}
            </div>
            <div className="p-4">
              <div className="font-display text-base truncate">{s.name}</div>
              <div className="mt-1 inline-flex items-center gap-1 text-[0.62rem] uppercase tracking-[0.16em]"
                style={{ color: "#16A34A" }}>
                <ShieldCheck size={11} /> {s.verified_listings} verified
              </div>
              {s.brands.length > 0 && (
                <div className="mt-1 text-xs text-neutral-500 truncate">{s.brands.join(" · ")}</div>
              )}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
